var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenFolderIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_54836",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 5,
    width: 25,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 28.625V5.375H28.125V28.625H4.875Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.75
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_54836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5 15.75C25.5 14.3522 25.5 13.4033 25.2716 12.8519C24.9672 12.1169 24.3831 11.5328 23.6481 11.2284C23.0967 11 22.3978 11 21 11C19.9714 11 18.9428 11 17.9142 11C17.7456 11 17.6613 11 17.5801 10.9956C16.8976 10.9585 16.2482 10.6896 15.7394 10.2332C15.6788 10.1788 15.6192 10.1192 15.5 10C15.3808 9.88077 15.3212 9.82116 15.2606 9.76683C14.7518 9.31043 14.1024 9.04145 13.4199 9.00441C13.3387 9 13.2544 9 13.0858 9C12.8239 9 12.5619 9 12.3 9C10.6198 9 9.77976 9 9.13803 9.32698C8.57354 9.6146 8.1146 10.0735 7.82698 10.638C7.5 11.2798 7.5 12.1198 7.5 13.8C7.5 15.9333 7.5 18.0667 7.5 20.2C7.5 21.8802 7.5 22.7202 7.82698 23.362C8.1146 23.9265 8.57354 24.3854 9.13803 24.673C9.77976 25 10.6198 25 12.3 25C13.7 25 15.1 25 16.5 25",
    stroke: "#10A37F",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16C7.5 16 7.5 18.8 7.5 20.2C7.5 21.8802 7.5 22.7202 7.82698 23.362C8.1146 23.9265 8.57354 24.3854 9.13803 24.673C9.77976 25 10.6198 25 12.3 25C15.1 25 17.9 25 20.7 25C22.3802 25 23.2202 25 23.862 24.673C24.4265 24.3854 24.8854 23.9265 25.173 23.362C25.342 23.0302 25.4237 21.4483 25.4631 19.8039C25.5 18.2673 25.5 16.6763 25.5 16H7.5Z",
    stroke: "#10A37F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenFolderIcon);
export default __webpack_public_path__ + "static/media/GreenFolderIcon.870ac449222cbb6d6b00dd6467d90b6a.svg";
export { ForwardRef as ReactComponent };